import { writable, get } from 'svelte/store';
import ComponentHome from '../pages/Home.svelte';
import ComponentAPropos from '../pages/APropos.svelte';
import ComponentPodcast from '../pages/Podcast.svelte';
import ComponentPodcastsCategory from '../pages/PodcastsCategory.svelte';
import { idPageHome, idPagePodcast, idPagePodcastsCategory, idPagePodcastCategories, idPageAPropos, namePageHome, namePagePodcast, namePagePodcastsCategory, namePagePodcastCategories, namePageAPropos, } from "./router2";
import { storePodcastCategory, storePodcast } from './classes/podcast';
import { PODCAST_CATEGORY_1, PODCAST_CATEGORY_2, PODCAST_CATEGORY_3 } from './constant';
import './common';
export const storeCurRoute = writable(idPageHome);
export const storeTitleRoute = writable("");
export const routes = [];
export const pageHome = { id: idPageHome, name: namePageHome, anchor: '', component: ComponentHome };
routes.push(pageHome);
export const pagePodcastCategories = { id: idPagePodcastCategories, name: namePagePodcastCategories, anchor: '', component: ComponentHome };
routes.push(pagePodcastCategories);
export const pagePodcast = { id: idPagePodcast, name: namePagePodcast, anchor: '', component: ComponentPodcast };
routes.push(pagePodcast);
export const pagePodcastsCategory = { id: idPagePodcastsCategory, name: namePagePodcastsCategory, anchor: '', component: ComponentPodcastsCategory };
routes.push(pagePodcastsCategory);
export const pageAPropos = { id: idPageAPropos, name: namePageAPropos, anchor: '', component: ComponentAPropos };
routes.push(pageAPropos);
/**
 * redirectTo
 *
 * @param path
 */
export function redirectTo(idPage, param = "") {
    storeCurRoute.set(idPage);
    const route = routes.filter((r) => r.id === idPage)[0];
    setHeaderTitle(idPage);
    // push the path into web browser history API
    window.history.pushState({ path: "#" + idPage }, '', window.location.origin + "/" + idPage + param);
}
/**
 * historyNavigation
 * Écoute de l’événement popstate qui est lancé lorsque l’historique change.
 * Le clic sur le back du navigateur est écouté et la route courante actualisée
 *
 * @param event
 */
export function historyNavigation(event) {
    // change current router path
    if (event.state.path.indexOf("#") >= 0 && storeCurRoute != undefined) {
        storeCurRoute.set(event.state.path.replace('#', ''));
        setHeaderTitle(get(storeCurRoute));
    }
}
/**
 * redirectTo
 *
 * @param path
 */
export function setHeaderTitle(idPage) {
    const route = routes.filter((r) => r.id === idPage)[0];
    if (idPage == idPagePodcastsCategory) {
        switch (get(storePodcastCategory)) {
            case PODCAST_CATEGORY_1.id:
                storeTitleRoute.set(PODCAST_CATEGORY_1.label);
                break;
            case PODCAST_CATEGORY_2.id:
                storeTitleRoute.set(PODCAST_CATEGORY_2.label);
                break;
            case PODCAST_CATEGORY_3.id:
                storeTitleRoute.set(PODCAST_CATEGORY_3.label);
                break;
            default:
                break;
        }
    }
    else if (idPage == idPagePodcast) {
        storeTitleRoute.set(get(storePodcast).title);
    }
    else {
        storeTitleRoute.set(route.name);
    }
}
